import * as yup from 'yup'

import { EMAIL_REGEX, PHONE_MAX_LENGTH, PHONE_REGEX } from '@/constants'
import { TTranslationFunction } from '@/types'

export const emailSchema = (t: TTranslationFunction) =>
	yup.string().matches(EMAIL_REGEX, {
		message: t('ui__field_validation_errors__email__generic'),
		excludeEmptyString: true,
	})

export const phoneSchema = (t: TTranslationFunction) =>
	yup.string().matches(PHONE_REGEX, {
		message: t('ui__field_validation_errors__phone__max_length', {
			maxDigits: PHONE_MAX_LENGTH,
		}),
		excludeEmptyString: true,
	})

export const maxLengthSchema = (length: number, t: TTranslationFunction) =>
	yup
		.string()
		.max(length, t('ui__field_validation_errors__generic__max_length', { length }))
